import React from 'react';
import { AIToolInvocation } from 'Generated/schema';

export interface ToolInvocationContextValues {
  toolInvocations: AIToolInvocation[];
  streamId: string;
  isCancelled: boolean;
}

const ToolInvocationContext = React.createContext<ToolInvocationContextValues | null>(null);

export const ToolInvocationProvider = ToolInvocationContext.Provider;

export const useToolInvocationContext = () => React.useContext(ToolInvocationContext);

export default ToolInvocationContext;
